import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const CURRENCIES = ["USD", "EUR", "GBP", "AUD", "CAD", "NZD", "JPY", "INR", "BRL", "ZAR", "AED", "CHF"];
const SYMBOLS = { USD: "$", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$", NZD: "NZ$", JPY: "¥", INR: "₹", BRL: "R$", ZAR: "R", AED: "د.إ", CHF: "CHF " };

const CurrencyCtx = createContext(null);

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [rates, setRates] = useState(null);
  const [currency, setCurrency] = useState("USD");

  useEffect(() => {
    api.get("/currency/rates").then(r => setRates(r.data.rates)).catch(() => setRates({ USD: 1 }));
  }, []);

  useEffect(() => {
    if (user && user !== false && user.preferred_currency) setCurrency(user.preferred_currency);
  }, [user]);

  const rate = rates?.[currency] ?? 1;

  const change = async (c) => {
    setCurrency(c);
    try { await api.post(`/users/me/currency?currency=${c}`); } catch (_) {}
  };

  const fmt = (usd) => {
    const v = Number(usd || 0);
    if (currency === "USD") return `$${v.toFixed(2)}`;
    return `${SYMBOLS[currency] || ""}${(v * rate).toFixed(2)} ${currency}`;
  };

  const fmtDual = (usd) =>
    currency === "USD" ? fmt(usd) : `${fmt(usd)} ≈ $${Number(usd || 0).toFixed(2)} USD`;

  return (
    <CurrencyCtx.Provider value={{ currency, change, fmt, fmtDual, rate, rates }}>
      {children}
    </CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);
